import React, { useContext } from 'react';
import styled, { keyframes } from 'styled-components';
import { HrPrimary, HrCubicBezier, HrSecondary, HrlightGrey, HrFont } from '@components/styles/hr-styles';
import { DisplaySettingsContext } from '../../postulation_form/store/display-settings';

const Bounce = keyframes`
  0% {
    width: 80%;
    height: 80%;
  }
  50% {
    width: 20%;
    height: 20%;
  }
  100% {
    width: 60%;
    height: 60%;
  }
`;

const Label = styled.label`
  font-family: ${HrFont};
  font-size: ${(props) => `${14 + (props.fontSizeSetting || 0)}px`};
  display: flex;
  align-items: center;
  color: ${(props) => props.color || HrSecondary};
  gap: 8px;
  margin: 0;

  > span {
    width: 20px;
    height: 20px;
    border: 2px solid ${HrlightGrey};
    border-radius: 50%;
    display: grid;
    place-items: center;
    box-sizing: border-box;
    cursor: pointer;

    .circle {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: transparent;
    }
  }
  & > input[type='radio']:checked ~ span {
    background-color: ${HrPrimary};
    border: none;
    width: 20px;
    height: 20px;
    border: 2px solid ${HrPrimary};

    .circle {
      background-color: white;
      animation: ${Bounce} 0.5s ${HrCubicBezier};
    }
  }

  & input[type='radio'] {
    display: none;
  }
`;

function Customlabel(props) {
  const { name, text, value, checked, register, disabled, onClick, onChange, id } = props;
  return (
    <Label onClick={onClick} onChange={onChange}>
      <input type='radio' value={value} defaultChecked={checked} {...register(name)} disabled={disabled} id={id} />
      <span>
        <span className='circle' />
      </span>
      {text}
    </Label>
  );
}

export const RadioCircle = ({ name, text, value, checked, register, control, disabled, onClick, onChange, id }) => {
  return (
    <Customlabel
      name={name}
      text={text}
      value={value}
      checked={checked}
      disabled={disabled}
      register={register}
      id={id}
      onClick={onClick}
      onChange={onChange}
    />
  );
};

export const RadioStyle = ({ name, text, value, checked, disabled, onClick, onChange, ref }) => {
  const { darkMode, fontSizeSetting } = useContext(DisplaySettingsContext);

  return (
    <>
      <Label fontSizeSetting={fontSizeSetting} color={darkMode ? 'white' : ''} onClick={onClick} onChange={onChange}>
        <input type='radio' ref={ref} name={name} value={value} disabled={disabled} defaultChecked={checked} />
        <span>
          <span className='circle' />
        </span>
        {text}
      </Label>
    </>
  );
};
